// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/developers.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "._4y0O60T3x{position:relative;height:120px}.cPXaCd2ux{height:120px;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat bottom center;position:absolute;width:100%}._3bSodNCwx{display:flex;justify-content:center;position:absolute;width:100%;z-index:-1;height:120px;opacity:0.25}\n", ""]);
// Exports
exports.locals = {
	"container": "_4y0O60T3x",
	"foreground": "cPXaCd2ux",
	"background": "_3bSodNCwx"
};
module.exports = exports;
